import React, { useState, useEffect } from "react";
import style from "../../style/DutySchedule.module.scss";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import PenToSquareRegular from "../Icon/PenToSquareRegular";
import dayjs from "dayjs";
import Logger from "../../libraries/Logger";
import DoctorDetailModal from "../Modal/DoctorDetailModal";
import { DoctorScheduleList } from "../../Data/DoctorScheduleList";

function DutyMonthScheduleListBody({ data }) {
  const [isOtherHospital, setIsOtherHospital] = useState(null);
  const [open, setOpen] = useState([]);
  const [cursor, setCursor] = useState(false);
  useEffect(() => {
    setIsOtherHospital(
      JSON.parse(localStorage.getItem("auth"))?.IsOtherHospital
    );
  }, [isOtherHospital]);

  const getDay = (DayValue, index) => {
    if (DayValue.isName === false) {
      return <li className={style.day}>{DayValue.DoctorName}</li>;
    } else {
      return (
        <li className={style.day}>
          <a href="#" className={style.duty_person}>
            {DayValue.DoctorName}
          </a>
          <div className={style.duty_tel} key={index}>
            {DayValue.subListData?.map((value, subindex) => {
              return (
                <div className={style.tel} key={subindex}>
                  {value}
                </div>
              );
            })}
          </div>
        </li>
      );
    }
  };
  const theadNeurologiesContent = [
    "時段",
    "日",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
  ];
  
  // console.log(data);
  const dateNeurologiesArray = data?.DutyList.map((v) => {
    return { ...v, Date: new Date(v.Date) };
  });
  // console.log(dateNeurologiesArray);
 

  const weeksNeurologies = dateNeurologiesArray?.reduce((result, date) => {
    const weekStart = new Date(date.Date);
    weekStart.setDate(date.Date.getDate() - date.Date.getDay());
    const weekEnd = new Date(date.Date);
    weekEnd.setDate(date.Date.getDate() - date.Date.getDay() + 6);
    const weekKey = `${weekEnd.getFullYear()}-${
      weekEnd.getMonth() + 1
    }-${weekEnd.getDate()}`;
    const week = result[weekKey] || {
      dates: [],
      weekStartDay: new Date(date.Date).getDay(),
    };
    week.dates.push(date);
    return {
      ...result,
      [weekKey]: week,
    };
  }, {});

  // Add logic to fill the last week with 7 days
  const lastWeekKeyN =
    weeksNeurologies &&
    Object.keys(weeksNeurologies)[Object.keys(weeksNeurologies).length - 1];
  const lastWeekN = lastWeekKeyN && weeksNeurologies[lastWeekKeyN];
  const lastWeekDatesCountN = lastWeekN && lastWeekN.dates.length;

  if (lastWeekDatesCountN < 7) {
    const lastDate = lastWeekN.dates[lastWeekDatesCountN - 1].Date;
    const remainingDays = 7 - lastWeekDatesCountN;

    for (let i = 1; i <= remainingDays; i++) {
      lastWeekN.dates.push({ Date: null, List: [{}, {}, {}, {}] });
    }
  }

  const dataNeurologiesReset =
    weeksNeurologies && Object?.values(weeksNeurologies);

    // console.log(dataNeurologiesReset)

  return (
    <div className={style.duty_month_info}>
      
        <table className={style.table} style={{ tableLayout: "fixed" }}>
          <thead>
            <tr className={style.table_title}>
              {theadNeurologiesContent?.map((v, i) => {
                return (
                  <th
                    className={style.table_title_self}
                    key={i}
                    style={{ color: "#575757" }}
                  >
                    {v}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {dataNeurologiesReset?.map((weekV, weekI) => {
              return (
                <tr className={style.table_body} key={weekI}>
                  <td className={style.table_body_self}>
                    <div style={{ color: "#575757" }}>日期</div>
                    <div style={{ color: "#575757" }}>08至12</div>
                    <div style={{ color: "#575757" }}>12至16</div>
                    <div style={{ color: "#575757" }}>16至20</div>
                    <div style={{ color: "#575757" }}>20至08</div>
                  </td>
                  {Array(weekV?.weekStartDay)
                    .fill(1)
                    .map((day, i) => {
                      return (
                        <td key={i} className={style.table_body_self}>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </td>
                      );
                    })}
                  {weekV?.dates?.map((dayV, dayI) => {
                    return (
                      <td className={style.table_body_self} key={dayI}>
                        <div style={{ color: "#c5c6c7" }}>
                          {dayV.Date === null ? "" : dayV.Date.getDate()}
                        </div>
                        {dayV?.List?.map((timeV, timeI) => {
                          return (
                            <div
                              style={{
                                cursor: cursor ? "no-drop" : "pointer",
                                color: " #1675e0",
                              }}
                              key={timeI}
                              onClick={() => {
                                if (timeV?.Name != null) {
                                  setOpen([
                                    { open: true },
                                    { title: "取栓值班醫師" },
                                    { Identity: timeV?.Identity },
                                    { name: timeV?.Name },
                                    {
                                      number: [
                                        timeV?.PhoneNumber,
                                        timeV?.ShortNumber,
                                        timeV?.ExtensionNumber,
                                      ],
                                      time: [
                                        timeV?.StartDateTime,
                                        timeV?.EndDateTime,
                                      ],
                                    },
                                  ]);
                                }
                              }}
                              onMouseEnter={() => {
                                if (timeV?.Name == null) {
                                  setCursor(true);
                                }
                              }}
                              onMouseLeave={() => {
                                setCursor(false);
                              }}
                            >
                              {timeV?.Name}
                            </div>
                          );
                        })}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
     
   
      <DoctorDetailModal open={open} setOpen={setOpen} />
    </div>
  );
}

export default DutyMonthScheduleListBody;
